import { Container } from '@mantine/core';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Layout } from './Layout';
import { Loading } from './Loading';

/** Everything behind the sign in wall renders through here. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <Container size="md" py="xl">
        <Loading label="Checking your sign in" />
      </Container>
    );
  }
  if (status === 'signed_out') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Layout />;
}
